<template>
    <div style="height: 0px; position: relative">
        <router-link v-if="!authenticated" :to="{ name: 'register' }" tag="v-icon">
            <v-btn absolute small tile color="primary" style="top: 10px; right: 80px" class="elevation-24"> Solicite Acesso </v-btn>
        </router-link>

        <router-link v-if="!authenticated" :to="{ name: 'login' }" tag="v-icon">
            <v-btn absolute small tile color="white" style="top: 10px; right: 5px" class="elevation-24">Login</v-btn>
        </router-link>

        <v-menu v-if="authenticated" :close-on-click="true" :close-on-content-click="true" v-model="menuOpenned">
            <template v-slot:activator="{ on }">
                <v-btn absolute fab color="primary" class="elevation-24" style="top: 10px; right: 20px" v-on="on">
                    <v-icon>menu</v-icon>
                </v-btn>
            </template>
            <v-card class="mx-auto" width="256" tile>
                <v-list>
                    <v-list-item>
                        <v-list-item-icon>
                            <!-- <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img> -->
                            <v-icon color="primary">person</v-icon>
                        </v-list-item-icon>
                    </v-list-item>

                    <v-list-item link>
                        <v-list-item-content>
                            <v-list-item-title class="title">Olá, {{ auth.getName() }}!!!</v-list-item-title>
                            <v-list-item-subtitle>{{ auth.getEmail() }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-icon>mdi-menu-down</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list nav dense>
                    <v-list-item-group color="primary" v-model="currentMenu">
                        <router-link v-for="(route, i) in routesFilter" :key="i" :to="route.path ? route.path : '/'" tag="v-list-item">
                            <v-list-item v-bind="verify(route.name, i)" :key="i">
                                <v-list-item-icon v-if="route.icon">
                                    <v-icon v-text="route.icon" color="primary"></v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title v-if="route.title">{{ route.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                    </v-list-item-group>
                    <v-list-item-group color="primary">
                        <router-link :to="{ name: 'home' }" v-on:click.native="auth.logout()">
                            <v-list-item class="text-center">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-btn dark color="primary"> <v-icon left dark>exit_to_app</v-icon>Logout </v-btn>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </router-link>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import auth from "../../helpers/auth";
import { routes } from "./../../routes";
export default {
    name: "Menu",
    props: {
        authenticated: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            currentMenu: -1,
            routes,
            auth,
            menuOpenned: false,
        };
    },
    methods: {
        verify(route, i) {
            if (route == this.$router.currentRoute.name) this.currentMenu = i;
        },
    },
    computed: {
        routesFilter() {
            return this.routes.filter((route) => auth.verifyRole(route.role) && (route.icon || route.title));
        },
    },
};
</script>